import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import { useOrderActions } from '../../../../../contexts/OrderActionsContext';
import { useOrderItemsModule } from '../../../OrderForm/contexts/OrderItemsModuleContext';
import { useSteelItems } from '../contexts/SteelItemsContext';
import { OrderSchemaType } from '../order.schema';

export interface SubmitHelpers {
  setHasValidationError: (value: boolean) => void;
  itemsPayload: unknown[];
}

interface SteelOrderSaveBridgeProps {
  onValidSubmit: (data: OrderSchemaType, helpers: SubmitHelpers) => void;
  onInvalidSubmit: () => void;
  onGuardFailure: () => void;
  onSubmitRefChange?: (submit: () => void) => void;
}

/**
 * Registra o save no subheader. Vive aqui dentro, e não na página, porque a guarda de itens é do
 * módulo e o formulário nasce no `OrderForm` — nenhum dos dois existe acima desta árvore.
 */
const SteelOrderSaveBridge: React.FC<SteelOrderSaveBridgeProps> = ({
  onValidSubmit, onInvalidSubmit, onGuardFailure, onSubmitRefChange,
}) => {
  const { handleSubmit } = useFormContext<OrderSchemaType>();
  const { setSaveOrderHandler } = useOrderActions();
  const { validateBeforeSave, buildItemsPayload } = useOrderItemsModule();
  const { setHasValidationError } = useSteelItems();

  useEffect(() => {
    const submit = () => {
      if (!validateBeforeSave().ok) {
        onGuardFailure();
        return;
      }
      handleSubmit((data) => onValidSubmit(data, { setHasValidationError, itemsPayload: buildItemsPayload() }), onInvalidSubmit)();
    };
    onSubmitRefChange?.(submit);
    setSaveOrderHandler(submit);
    return () => setSaveOrderHandler(null);
  }, [handleSubmit, setSaveOrderHandler, validateBeforeSave, buildItemsPayload, setHasValidationError, onValidSubmit, onInvalidSubmit, onGuardFailure, onSubmitRefChange]);

  return null;
};

export default SteelOrderSaveBridge;
